<template>
  <div>
    <el-upload
      :action="imgurl()"
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :headers="headers"
      :limit="limit"
      :before-upload="beforeAvatarUpload"
      :on-exceed="limitNum"
      :on-success="handleAvatarSuccess"
      :on-change="handleChange"
      :file-list="fileList"
      :on-remove="handleRemove"
      :auto-upload="true"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="imageUrl" alt/>
    </el-dialog>
  </div>
</template>

<script>
    import {getToken} from "@/utils/auth";
    import axios from 'axios';

    export default {
        name: "index",
        props: {
            limit: {
                type: Number,
                default:99
            },
            message:{
                type: String,
                default:""
            },
            value:{}
        },
        watch:{
            value:{
                immediate:true,
                handler:function(value){
                  if(!value){
                        this.fileList=[];
                        return;
                    }
                     console.log(value)
                    this.fileList=value.map((item,i)=>{
                        return {uid:i,url:item};
                    });
                }
            },

        },
        computed: {
            headers() {
                return {
                    "access-token": this.token // 直接从本地获取token就行
                };
            }
        },
        data() {
            return {token: getToken(), dialogVisible: false, imageUrl: "",fileList:[]}
        },

        methods: {
            imgurl() {
                return axios.defaults.baseURL + "/common/uploadFile";
            },

            handleRemove(file, fileList){

                this.$emit('input',fileList.map((item=>{
                    return item.url;
                })))

            },
            // 文件上传时的钩子
            handlePictureCardPreview(file, fileList) {
                this.imageUrl = file.url;
                this.dialogVisible = true;
            },
            // 文件超出个数限制时的钩子
            limitNum(file, fileList) {
                this.$message({  message: `最多只能上传${this.limit}张图片`,
                    type: "error"})
            },
            //文件上传成功时的钩子,拿到图片路径
            handleAvatarSuccess(res, file, fileList) {
                this.fileList.push({uid:fileList.length,url:file.response.data});
                this.$emit('input',this.fileList.map((item=>{
                    return item.url;
                })))
            },
            handleChange(file, fileList){


            },
            // 图片格式要求
            beforeAvatarUpload(file) {
                const isPNG = file.type === "image/png";
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isPNG && !isJPG) {
                    this.$message.error("上传图片只能是 JPG 格式和PNG格式!");
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 2MB!");
                }
                return isPNG || (isJPG && isLt2M);
            }
        }
    }
</script>

<style scoped>

</style>
